import React from "react";
// import { Fragment } from "react";
// import { Menu, Transition } from "@headlessui/react";
// import { BiChevronDown } from "react-icons/bi";
// import { AiFillStar } from "react-icons/ai";
// import { GoPrimitiveDot } from "react-icons/go";

import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import NavDropdown from "react-bootstrap/NavDropdown";
import Nav from "react-bootstrap/Nav";

import "./../App.css";

import Logo from "./../assets/images icons/1x/Image 12.png";

import countryLogo from "./../assets/images icons/1x/united-kingdom.png";


// function classNames(...classes) {
//   return classes.filter(Boolean).join(" ");
// }

function App() {
  return (
    <div>
      <Navbar collapseOnSelect expand="lg" bg="light" variant="dark">
        <Container>
          <Navbar.Brand href="#home">
            <img style={{ display: "flex", alignItems: "center" }} src={Logo} />
            <h3> &nbsp;&nbsp;&nbsp;Lorem</h3>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto"></Nav>
            <Nav>
              <Nav.Link href="#features">For Consultant</Nav.Link>
              <Nav.Link href="#pricing">For Users</Nav.Link>
              <Nav.Link href="#features">FAQ</Nav.Link>
              <Nav.Link href="#pricing">Blog</Nav.Link>

              <Nav.Link href="#pricing" className="signupbtn">
                Signup
              </Nav.Link>
              <Nav.Link
                href="#pricing"
                className="loginbtn"
                style={{ color: "white" }}
              >
                Login
              </Nav.Link>

              <NavDropdown title="" id="collasible-nav-dropdown">
                {/* <img src={countryLogo} /> */}
                <NavDropdown.Item href="#action/3.1">FAQ</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">
                  Another action
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">
                  Something
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.4">
                  Separated link
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="w-full flex flex-rows">
        <div className="w-1/2 full-mob h-96 flex justify-center items-center mt-28">
          <div className="w-80 h-lrge bg-white shadow-xl rounded p-2 text-center h-450">
            <p className="text-black text-2xl font-gilroy mt-4">
              Life is Good Find Now
            </p>
            <button className="text-base w-4/5 py-1.5 px-6 rounded-3xl border border-green mt-4">
              Signup
            </button>
            <button className="py-1.5 px-6 w-4/5 rounded-3xl border border-green bg-green mt-2 text-white">
              Login
            </button>
            <hr className="bg-gray-400 w-11/12 mt-4 mx-auto " />
            <p className="text-black text-2xl font-gilroy mt-4">
              Therapist Specialist
            </p>

            <input
              type="text"
              className="text-base w-5/6 py-1.5 px-6 rounded-3xl border border-green mt-4"
              placeholder="e.g Depression, Truma"
            />
            <input
              type="text"
              className="text-base w-5/6 py-1.5 px-6 rounded-3xl border border-green mt-2"
              placeholder="e.g Depression, Truma"
            />
            <button className="py-1.5 px-6 w-5/6 rounded-3xl border border-green bg-green mt-2 text-white">
              Search
            </button>
          </div>
        </div>
        <div className="w-1/2 full-mob">
          <img
            src={require("../assets/index/banner_bg.png")}
            alt=""
            className="w-3/4 mt-20 setimgmob"
          />
        </div>
      </div>
    </div>
  );
}

export default App;
